import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { ListaDifaisResponse } from '../../responses/motor-fiscal/lista-difais.response';
import { DifalResponse } from '../../responses/motor-fiscal/difal.response';
import { DifalSeedRequest } from '../../requests/motor-fiscal/difal-seed.request';
import { AtualizarDifalRequest } from '../../requests/motor-fiscal/atualizar-difal.request';
import { DifalSalvarResponse } from '../../responses/motor-fiscal/difal-salvar.response';
import { TipoFormulaEnum } from '../../../enums/formula/tipo-formula.enum';

@Injectable({ providedIn: 'root' })
export class DifalService extends CommonService {
    private readonly apiUrl: string = environment.urlApiMotorFiscal + 'Difal';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(
        idUnidadeFederativa: number | null,
        tipoFormula: TipoFormulaEnum | null,
        modeloFormula: string | null,
        somenteReducaoBc: boolean | null,
        paginaAtual: number,
        tamanhoPagina: number
    ): Observable<ListaDifaisResponse> {
        let params = new HttpParams()
            .set('paginaAtual', paginaAtual.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (idUnidadeFederativa) params = params.set('idUnidadeFederativa', idUnidadeFederativa.toString());
        if (tipoFormula !== null) params = params.set('tipoFormula', tipoFormula.toString());
        if (modeloFormula) params = params.set('modeloFormula', modeloFormula);
        if (somenteReducaoBc) params = params.set('somenteReducaoBc', somenteReducaoBc.toString());

        return this.httpClient.get<ListaDifaisResponse>(`${this.apiUrl}/all`, {
            params,
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public seed(request: DifalSeedRequest): Observable<ReturnStruct> {
        return this.httpClient.post<ReturnStruct>(`${this.apiUrl}/seed`, request, {
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public getCompleto(id: number): Observable<DifalResponse> {
        return this.httpClient.get<DifalResponse>(`${this.apiUrl}/${id}/completo`, {
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public atualizarCompleto(id: number, request: AtualizarDifalRequest): Observable<DifalSalvarResponse> {
        return this.httpClient.put<DifalSalvarResponse>(`${this.apiUrl}/${id}/completo`, request, {
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

}
